import {predicate} from "./MutualParams";


const array={
    name:"array",
    type:"Type[]",
    description:"array to remove an item from",
};
export default {
    id:"removeItem",
    typedynamic:true,
    type:"function",
    overloads:[
        {
            type:"(array:Type[],item:Type):Type",
            props:[
                array,
                {
                    name:"item",
                    type:"Type",
                    description:"item to remove",
                },
            ],
        },
        {
            type:"(array:Type[],predicate:function):Type",
            props:[
                array,
                {
                    ...predicate,
                    description:predicate.description+"@if such item is found, it's removed",
                },
            ],
        },
    ],
    returns:{
        type:"type|null",
        description:"the removed item or null if no item is removed",
    },
}
